import './participantLine.scss';

import {
  ActionIcon,
  ActionIconColor,
  ActionIconVariant,
  Size,
  Skeleton,
} from '@eliberty/design-system-react';

import { FormattedCurrency, ParticipantTitle } from '~atoms';
import { SELECTOR_MODE } from '~constants';
import { Participant } from '~types/participant';

interface Props {
  participant: Participant;
  price?: number;
  currency?: string;
  index: number;
  isOnError?: boolean;
  participantMode: SELECTOR_MODE;
  isLoading?: boolean;
  allParticipants?: Participant[];
  onDeleteClick: (participantId: number) => void;
}

const ParticipantLine = ({
  participant,
  price,
  currency,
  index,
  isOnError = false,
  participantMode,
  isLoading = false,
  allParticipants,
  onDeleteClick,
}: Props) => {
  return (
    <div className='ParticipantLine' data-testid={`participant-line-${index}`}>
      <div className='ParticipantLine_title'>
        <ActionIcon
          label='Icon delete'
          size={Size.S}
          variant={ActionIconVariant.Ghost}
          icon='action-delete'
          color={ActionIconColor.Black}
          onClick={() => onDeleteClick(participant.id)}
          data-testid={`ParticipantLine_removeButton_${index}`}
        />
        <ParticipantTitle
          index={index}
          participant={participant}
          participantMode={participantMode}
          allParticipants={allParticipants}
        />
      </div>
      <div className={`ParticipantLine_price ${isOnError ? 'ParticipantLine_price-onError' : ''}`}>
        {isLoading && <Skeleton data-testid='Skeleton' width='70px' height='24px' />}
        {!isLoading &&
          (price !== undefined && currency !== undefined ? (
            <FormattedCurrency value={price} currency={currency} />
          ) : (
            <div className='ParticipantLine_price-noPrice'>--</div>
          ))}
      </div>
    </div>
  );
};

export default ParticipantLine;
